import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function LinkIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect fill="currentColor" opacity="0" x="0" y="0" width="16" height="16" />
        <g transform="translate(2.000000, 2.000000)">
          <path
            d="M5.79181928,6.1171875 C5.89963178,6.1171875 6.00744428,6.075 6.09181928,5.9859375 L10.0058818,2.0765625 L10.7043193,1.2796875 L10.6293193,3.20625 L10.6293193,4.621875 C10.6293193,4.846875 10.8168193,5.0484375 11.0511943,5.0484375 C11.2761943,5.0484375 11.4730693,4.85625 11.4730693,4.603125 L11.4730693,0.45 C11.4730693,0.1828125 11.2996318,0 11.0230693,0 L6.86525678,0.009375 C6.60275678,0.009375 6.42931928,0.20625 6.42931928,0.43125 C6.42931928,0.65625 6.62619428,0.84375 6.85119428,0.84375 L8.17775678,0.84375 L10.1886943,0.76875 L9.39650678,1.4671875 L5.49181928,5.38125 C5.40275678,5.4703125 5.35588178,5.578125 5.35588178,5.68125 C5.35588178,5.90625 5.55744428,6.1171875 5.79181928,6.1171875 Z"
            id="icon"
            fill="currentColor"
            fillRule="nonzero"
          />
          <path
            d="M3.61632052,0.6 L1,0.6 C0.44771525,0.6 3.76453835e-16,1.04771525 0,1.6 L0,10.4540103 C6.76353751e-17,11.0062951 0.44771525,11.4540103 1,11.4540103 L9.99743687,11.4540103 C10.5497216,11.4540103 10.9974369,11.0062951 10.9974369,10.4540103 L10.9974369,7.76001169 L10.9974369,7.76001169"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export { LinkIcon };
